import Logger from '@/logger'

const LOG_NAME = 'Analytics'

export default {
    methods: {
        /**
         * Tracks an event using Google Analytics.
         * @param {string} category The event category.
         * @param {string} action The event itself.
         * @param {?string} additional Optional additional data to be added to the event action.
         * @param {?string} label Optional label for the action.
         * @param {?string} value Optional value for the action.
         */
        trackEvent(category, action, { additional, label, value } = {}) {
            if (!this.$gtag) {
                Logger.log('Google Analytics disabled', LOG_NAME)
                return
            }

            const eventAction = `${ action }${ (additional ? `_${ additional }` : '') }`.toLowerCase().split(' ').join('_')
            const eventParams = {
                'event_category': category,
            }
            // eslint-disable-next-line camelcase
            if (label) eventParams.event_label = label
            if (value) eventParams.value = value

            Logger.logObject({ category, eventAction, eventParams }, 'Sending event to analytics', LOG_NAME)
            this.$gtag.event(eventAction, eventParams)
        },
    },
}
